import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Box } from '@lightspeed/flame/Core';
import { Input, InputProps } from '@lightspeed/flame/Input';
import { Text } from '@lightspeed/flame/Text';

export const SectionHeading = styled.h3`
  &&& {
    padding: 3px 12px;
    border-bottom: 1px solid #777;
    text-transform: initial;
    font-size: 16px;
    line-height: 24px;
    background: #d6dffd;
    letter-spacing: normal;
  }
`;

export const SectionTitle = styled(Text)`
  color: #020203;
  font-weight: bold;
  margin-bottom: 1rem;
`;

export const RadioContainer = styled(Box)`
  max-width: 310px;
  margin-right: 1rem;
  input {
    align-self: flex-start;
  }
`;

export const KeensMustard = '#ffce54';

export const PercentageInput = styled(Input)<InputProps & { status?: 'error' | '' }>`
  width: 30px;
  &&& {
    border: none;
  }
  &:focus {
    box-shadow: none;
  }
`;

export const PercentageText = styled(Text)`
  &&& {
    line-height: 2.4;
  }
`;

export const MarginFilterToggleButton = styled(Button)`
  background: none;
  border: none;
  font-weight: normal;
  text-decoration: underline;
  white-space: nowrap;
  color: #020203;
  &:active,
  &:focus,
  &:hover,
  &:target,
  &:visited {
    border: none;
    outline: none;
    box-shadow: none;
  }
`;

export const ErrorMsg = styled(Text)`
  color: #de2e37;
`;
